export default {
    "PUB": "PUB Singapore"
};



// WEBPACK FOOTER //
// ./src/util/nameMapping.js